export class Reserva{
    Id_of:number;
    Id_grupoMaquinas:number;
    Id_maquina:number;
    Id_grupo:number;
    FechaInicio:Date;
    FechaFin:Date;
    Id_alumnos:string;
}